/* Connectivity signal, shared across raftor_webhq's storefront JS.
 *
 * Wraps navigator.onLine + the online/offline window events, and where
 * supported, the Network Information API's navigator.connection.effectiveType
 * ("slow-2g"|"2g"|"3g"|"4g") + its own "change" event, into one small event
 * bus. No UI of its own -- other modules (cart_resilience.js,
 * order_success_redirect.js, catalog fetch code) subscribe to this instead
 * of each rolling their own listeners.
 *
 * navigator.connection isn't universally supported (notably: no Safari) --
 * this degrades to online/offline-only there rather than throwing, since a
 * feature this small isn't worth a hard dependency on it.
 */
(function () {
	if (window.RaftorConnectivity) return;

	function getConnection() {
		return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
	}

	function currentState() {
		var conn = getConnection();
		return {
			online: typeof navigator.onLine === "boolean" ? navigator.onLine : true,
			effectiveType: (conn && conn.effectiveType) || null,
			saveData: !!(conn && conn.saveData),
		};
	}

	var listeners = [];

	function notify() {
		var state = currentState();
		listeners.forEach(function (cb) {
			try {
				cb(state);
			} catch (e) {
				// A subscriber's own bug must never break connectivity reporting
				// for every other subscriber.
			}
		});
	}

	window.addEventListener("online", notify);
	window.addEventListener("offline", notify);

	var conn = getConnection();
	if (conn && typeof conn.addEventListener === "function") {
		conn.addEventListener("change", notify);
	}

	window.RaftorConnectivity = {
		/** Point-in-time snapshot: {online, effectiveType, saveData}. */
		state: currentState,

		/** Subscribe to any online/offline/effectiveType change. Returns an unsubscribe function. */
		on: function (cb) {
			if (typeof cb !== "function") return function () {};
			listeners.push(cb);
			return function () {
				var idx = listeners.indexOf(cb);
				if (idx !== -1) listeners.splice(idx, 1);
			};
		},

		/** Convenience: true on a connection slow enough that non-essential
		 * requests should be deferred or serialized rather than fired in
		 * parallel (Phase 3's use case), or when the user has explicitly
		 * asked the browser to reduce data usage. */
		isSlow: function () {
			var s = currentState();
			return s.effectiveType === "slow-2g" || s.effectiveType === "2g" || s.saveData;
		},
	};
})();
